import isMobileOrIPad from '@anm/helpers/is/isMobileOrIPad';
import {
  DASHBOARD_CONTENT_WRAPPER_WIDTH,
  DASHBOARD_NAVBAR_WIDTH
} from '@anm/styles/constants';
import { useRef } from 'react';

const useNotificationPosition = () => {
  const notificationLeftPosition = !isMobileOrIPad()
    ? `${DASHBOARD_NAVBAR_WIDTH + DASHBOARD_CONTENT_WRAPPER_WIDTH}px`
    : '50%';
  const notificationTranslate = !isMobileOrIPad()
    ? `${DASHBOARD_CONTENT_WRAPPER_WIDTH}px`
    : '0px';
  const notificationTopPosition = '108px';

  const notificationPosition = useRef({
    top: notificationTopPosition,
    left: notificationLeftPosition,
    translateX: notificationTranslate
  }).current;

  return [notificationPosition];
};

export default useNotificationPosition;
